import { ViewType } from '@audacy-clients/client-services';
import { useModuleContext } from '@audacy-clients/core/components/ModuleRenderer/context';
import BannerAd from '~/components/BannerAd';

const ModuleBannerAd: React.FC = () => {
  // BannerAd placement on SHOW pages must be handled within the ModuleShowLiveNowAndPreviousEpisodes
  const isShow = useModuleContext().viewType === ViewType.SHOW;
  if (isShow) return <></>;

  return <BannerAd />;
};

export default ModuleBannerAd;
